import React, { useState } from 'react';
import logo from '../assets/logo-dark.png';
import { useHistory } from 'react-router-dom';
import { updateCompany, useAuth } from 'api';
import {
  Form,
  Input,
  Title,
  Text,
  Button,
  Notice,
} from 'ui';


export default function AuthCompany() {
  
  const auth = useAuth();
  const history = useHistory();
  const [error, setError] = useState("");
  const [value, setValue] = useState({});
  
  if(!auth) {
    return null;
  }
  
  if(!auth.company.id) {
    return <Notice text="No company found."/>;
  }
  
  async function submit() {
    if(!value.name) {
      setError("Please enter a company name.");
      return;
    }
    
    if(!value.street || !value.city || !value.state || !value.zip) {
      setError("Please enter a company address.");
      return;
    }
    
    try {
      await updateCompany(auth.company.id, value);
    }
    catch(error) {
      setError(error.message);
      return;
    }
    
    history.push('billing');
  }
  
  return (
    <div className="auth-screen">
      <img src={logo} alt="Taptivate" className="auth-logo"/>
      
      <Title className="auth-title">
        Create a Company<br/>
        <br/>
      </Title>
      
      <Text color="red" className="auth-error">{error || ""}</Text>
      
      <div className="auth-2col">
        
        <div className="auth-card">
          <Form value={value} onChange={setValue} onSubmit={submit} className="auth-form">
            <Title className="auth-title">Company Info.</Title>
            <Input outline name="name" label="Company" className="auth-input"/>
            <div className="auth-address">
              <Input outline name="street" label="Street" className="auth-input"/>
              <Input outline name="city" label="City" className="auth-input"/>
              <Input outline name="state" label="State" className="auth-input"/>
              <Input outline name="zip" label="Zip" className="auth-input"/>
            </div>
            <Input outline name="gaCode" label="Google Analytics" className="auth-input" placeholder="UA-XXXXXXXXX-X"/>
            <Button className="auth-button" onClick={submit}>Continue to Billing</Button>
          </Form>
        </div>
        
        <div className="auth-card">
          <Title>{auth.company.plan.name} Plan</Title>
          <Text block style={{marginBottom:8}}>${auth.company.plan.cost/100}.00 / {auth.company.plan.cycle}</Text>
          <Text block small style={{marginBottom:8}}>Your receipt will be sent to {auth.company.email}</Text>
          <Button tertiary to="plan">
            <Text orange small>Change Plan</Text>
          </Button>
        </div>
      
      </div>
    </div>
  );
}